const QueryKeys = {
  list: 'streams/measurements/list',
};

export default QueryKeys;
